import { useContext } from 'react'
import { ListWrapper } from '../list-wrapper/list-wrapper'
import { ShopByBrandThumbnail } from '../shop-by-brand-thumbnail/shop-by-brand-thumbnail'
import styles from './brands-list.module.css'
import { SharedUiHeaderV2Context } from '../../context/context-shared-ui-header-v2'
import { parentLinks } from '../../../data/parent-menu'
import { NewCarBrands } from '../../../data/shared'

interface BrandsListProps {
  brandsList: NewCarBrands[]
}

export const BrandsList = ({ brandsList }: BrandsListProps) => {
  const { logicStore } = useContext(SharedUiHeaderV2Context)

  const { handleTrackEvent } = logicStore

  return brandsList.map((type) => (
    <ListWrapper
      key={type.sectionTitle}
      heading={type.heading}
      urlText={type.sectionLink}
      href={type.href}
    >
      <div className={styles.shopByBrandContainer}>
        {type.cards.map((item) => (
          <ShopByBrandThumbnail
            key={item.label}
            title={item.label}
            href={item.href}
            image={item.image}
            alt={item.alt}
            handleTrackEvent={() =>
              handleTrackEvent({
                name: 'click',
                category: 'mega menu',
                label: parentLinks.NEWCARS,
                action: 'shop by type',
                value: item.label,
              })
            }
          />
        ))}
      </div>
    </ListWrapper>
  ))
}
